import { gameLibrary } from '../configs/gameLibrary';
/**
 * Strip non-alphanumeric characters (including apostrophes) and PascalCase.
 * "Too Many Cooks" -> "TooManyCooks"
 * "Finish Each Other's Sandwiches" -> "FinishEachOthersSandwiches"
 */
function deriveCodeFolder(gameName) {
    return gameName
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
}
function deriveCoverAssetKey(gameName) {
    return `cover${deriveCodeFolder(gameName)}`;
}
function deriveDiscoverySlug(gameName) {
    return gameName
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-');
}
// Generic helper to find a game by ID
function findGame(gameId) {
    return gameLibrary.find((g) => g.gameCore.gameId === gameId);
}
// Helper functions to get specific properties using a game id
export function findGameName(gameId) {
    return findGame(gameId)?.gameCore.gameName;
}
export function isGameTeamGame(gameId) {
    return findGame(gameId)?.gameCore.isTeamGame;
}
export function getGameTeamCount(gameId) {
    return findGame(gameId)?.gameCore.teamCount;
}
export function getGameCoverAssetKey(gameId) {
    const name = findGameName(gameId);
    return name ? deriveCoverAssetKey(name) : undefined;
}
export function getGameCodeFolder(gameId) {
    const name = findGameName(gameId);
    return name ? deriveCodeFolder(name) : undefined;
}
export function getGameImageGenerationConfig(gameId) {
    return findGame(gameId)?.imageGenerationConfig;
}
export function getGameBucketName(gameId) {
    const game = findGame(gameId);
    return game?.imageGenerationConfig?.bucketName ?? game?.assetBucketName;
}
export function getGameFallbackImage(gameId) {
    return findGame(gameId)?.imageGenerationConfig?.fallbackImage;
}
export function findGameDiscoverySlug(gameId) {
    const name = findGameName(gameId);
    return name ? deriveDiscoverySlug(name) : undefined;
}
export function findGameIdByDiscoverySlug(discoverySlug) {
    return gameLibrary.find((g) => deriveDiscoverySlug(g.gameCore.gameName) === discoverySlug)?.gameCore.gameId;
}
//# sourceMappingURL=getGames.js.map